<template>
  <main class="bg-white text-gray-800 py-16 px-4 lg:px-20 relative z-0">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 relative z-0">
      <!-- Left Section -->
      <div class="lg:sticky lg:top-16 self-start z-10 bg-white">
        <p class="uppercase text-gray-400 font-semibold text-sm mb-2">
          What we do?
        </p>
        <h2 class="text-2xl lg:text-3xl font-semibold leading-tight">
          The service we offer is
          <span class="italic text-yellow font-semibold">specifically</span>
          designed to meet your needs in all our subsidiaries.
        </h2>
        <p class="mt-6 mb-8 text-lg text-gray-600 leading-relaxed">
          At our core, we provide innovative and reliable solutions across
          construction, hospitality and consult. From personalized
          consultations to seamless service bookings and aftercare support, our
          offerings are tailored to ensure satisfying experience for every client we serve.
        </p>
        <router-link
          to="/services"
          class="mt-10 bg-yellow text-white px-6 py-3 rounded-lg transition-all"
        >
          More Details
        </router-link>
      </div>

      <!-- Right Section -->
      <div class="space-y-6 pr-2 lg:max-h-[80vh] lg:overflow-y-auto">
        <template v-for="(subsidiary, index) in subsidiaries" :key="index">
          <div class="flex items-start bg-white shadow-xl rounded-xl p-6">
            <img
              :src="subsidiary.image"
              alt="Service Icon"
              class="w-16 h-16 mr-5"
            />
            <div>
              <h3 class="text-xl font-semibold">
                {{ subsidiary.name }}
              </h3>
              <p class="text-gray-600 mt-2">
                {{ subsidiary.description }}
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      subsidiaries: [
        {
          name: "Mshel Homes",
          description:
            "We provide housing solutions tailored to modern lifestyles.",
          image: require("../assets/images/house.png"),
        },
        {
          name: "Lisa Suites",
          description:
            "We are a premier serviced apartment company offering luxurious home like accomodations with personalized service.",
          image: require("../assets/images/building.png"),
        },
        {
          name: "Mshel Prints",
          description:
            "We are your one stop shop for premium flex banners, SAVs, Brochures, Business cards and many more with expert craftmanship to deliver vibrant, high impact prints that is relevant to your brand",
          image: require("../assets/images/offset.png"),
        },
        {
          name: "Mshel Construction",
          description:
            "Innovative construction services with quality and durability.",
          image: require("../assets/images/hook.png"),
        },
        {
          name: "Mshel Blocks & Machineries",
          description: "Top-notch block production and machinery services.",
          image: require("../assets/images/construction (1).png"),
        },
        {
          name: "Mshel Consult",
          description: "Expert consulting services across various sectors.",
          image: require("../assets/images/consulting.png"),
        },
        {
          name: "Mshel Logistics",
          description: "Efficient logistics and supply chain solutions.",
          image: require("../assets/images/delivery-location.png"),
        },
        {
          name: "Mshel Foundation",
          description: "Empowering communities through impactful initiatives.",
          image: require("../assets/images/generous.png"),
        },
      ],
    };
  },
};
</script>

<style scoped></style>
